const quoraScriptUrl = 'https://a.quora.com/qevents.js';
const quoraId = process.env.REACT_APP_QUORA_ID;
const googleUniversalAnalyticsId = process.env.REACT_APP_GOOGLE_ID;
const googleGa4Id = process.env.REACT_APP_GTAG_GA4 || process.env.REACT_APP_GTAG_ID_ANALYTICS;
const googleAdsId = process.env.REACT_APP_GTAG_ID_GOOGLE_ADS || process.env.REACT_APP_GTAG_ID;

const hasBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';

const getRoutePath = (path) => {
  if (path) {
    return path;
  }
  if (!hasBrowser()) {
    return '';
  }
  return `${window.location.pathname}${window.location.search}${window.location.hash || ''}`;
};

const getTrackingState = () => {
  if (!hasBrowser()) {
    return {};
  }
  if (!window.__dtTracking) {
    window.__dtTracking = {};
  }
  return window.__dtTracking;
};

const ensureQuoraBootstrap = () => {
  if (!hasBrowser() || window.qp) {
    return;
  }
  const qp = function qpDispatcher() {
    if (qp.qp) {
      qp.qp.apply(qp, arguments);
    } else {
      qp.queue.push(arguments);
    }
  };
  qp.queue = [];
  window.qp = qp;
};

const ensureQuoraScript = () => {
  if (!hasBrowser()) {
    return;
  }
  if (document.getElementById('dt-quora-pixel')) {
    return;
  }
  const script = document.createElement('script');
  script.id = 'dt-quora-pixel';
  script.async = true;
  script.src = quoraScriptUrl;
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
};

const normalizeEmail = (email) => {
  const prepared = String(email || '').trim().toLowerCase();
  return prepared || '';
};

export const initializeQuoraTracking = (email) => {
  if (!quoraId || !hasBrowser()) {
    return;
  }
  const state = getTrackingState();
  ensureQuoraBootstrap();
  ensureQuoraScript();
  const normalizedEmail = normalizeEmail(email);
  if (!state.quoraInitialized) {
    window.qp.disablePushState = true;
    if (normalizedEmail) {
      window.qp('init', quoraId, { email: normalizedEmail });
    } else {
      window.qp('init', quoraId);
    }
    state.quoraInitialized = true;
    state.quoraEmail = normalizedEmail;
    return;
  }
  if (normalizedEmail && normalizedEmail !== state.quoraEmail) {
    window.qp('init', quoraId, { email: normalizedEmail });
    state.quoraEmail = normalizedEmail;
  }
};

export const trackQuoraEvent = (eventName = 'Purchase', data = {}, email) => {
  if (!quoraId || !hasBrowser()) {
    return;
  }
  initializeQuoraTracking(email);
  window.qp && window.qp('track', eventName, data);
};

export const trackGooglePageView = (path) => {
  if (!hasBrowser() || !window.gtag) {
    return;
  }
  const pagePath = getRoutePath(path);
  const payload = {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  };
  const ids = [googleUniversalAnalyticsId, googleGa4Id, googleAdsId].filter(Boolean);
  const uniqueIds = [...new Set(ids)];
  uniqueIds.forEach((id) => window.gtag('config', id, payload));
  window.gtag('event', 'page_view', payload);
};

export const trackFacebookPageView = () => {
  if (!hasBrowser() || !window.fbq) {
    return;
  }
  window.fbq('track', 'PageView');
};

export const trackQuoraPageView = (path, email) => {
  if (!quoraId || !hasBrowser()) {
    return;
  }
  initializeQuoraTracking(email);
  const pagePath = getRoutePath(path);
  window.qp && window.qp('track', 'ViewContent', { path: pagePath });
};

export const trackRoutePageView = (path, email) => {
  trackGooglePageView(path);
  trackFacebookPageView();
  trackQuoraPageView(path, email);
};
